<template>
    <div id="contendor-principal-VCDCV2" class="container-fluid">
        <!-- SECCION DE ENCABEZADOS -->
        <div id="encabezados">
            <h1>CREACIÓN DE CÉDULA PARA NOTIFICACIÓN</h1>
            <h4>Consulta, asigna o reasigna las cédula a los notificadores</h4>
            <div class="hr-titulo"></div>
        </div>

        <div class="d-flex justify-content-center" style="margin-top:3em;">
            <ul style="width: 40%;" class="progress">
                <li style="width: 50%;" @click="PASOS.DOS.activo = false, PASOS.UNO.activo = true" :class="[(PASOS.DOS.activo) ? 'beforeactive' : 'active']"><a>{{ PASOS.UNO.descripcion }}</a></li>
                <!-- <li class="beforeactive"><a href="">Develop</a></li> -->
                <li style="width: 50%;" @click="PASOS.UNO.activo = false, PASOS.DOS.activo = true" :class="[(PASOS.DOS.activo) ? 'active' : '']"><a>{{ PASOS.DOS.descripcion }}</a></li>
            </ul>
        </div>        
        <!-- FIN SECCION PASOS -->
        <!-- SECCION PRINCIPAL LAYOUT -->
        <div id="seccion-principal-VCDCV2" class="row no-gutters">

            <div v-show="PASOS.DOS.activo" class="card col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card-header">
                    <h5>Formulario de creacion</h5>
                </div>
                <div class="card-body"></div>
            </div>

            <div v-show="PASOS.UNO.activo" class="card col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card-header">
                    <h5>Formulario de creacion</h5>
                </div>
                <div class="card-body">
                    <!-- SECCION INFROMATIVA DE JUZGADO -->
                    <div v-if="!FILTROS.CONDICIONALES.esJuzgadoMixto" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 contenedor-encabezados-informativos">
                        <h6>Materia: {{ INFORMACION_AREA_USUARIO.MATERIA }}</h6>
                        <h6>Juzgado: {{ INFORMACION_AREA_USUARIO.NOMBRE_JUZGADO }}</h6>
                    </div>
                    <!-- FIN SECCION INFROMATIVA DE JUZGADO -->
                    <!-- SECCION FILTROS DE EXPEDIENTE -->
                    <div class="row no-gutters">
                        <!-- FILTRO DE MATERIA -->
                        <div v-if="FILTROS.CONDICIONALES.esJuzgadoMixto" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3">
                            <div class="form-group">
                                <h6>Materia</h6>
                                <C002Materias 
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioTipoMateria" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="FILTROS.MATERIA.ID" 
                                    :parametros="FILTROS.MATERIA.parametros" 
                                    :valorDefinido="FILTROS.MATERIA.valorDefinido" 
                                    :key="FILTROS.MATERIA.KEY + FILTROS.MATERIA.contRender"></C002Materias>
                            </div>
                        </div>
                        <!-- FILTRO DE JUZGADO -->
                        <div v-if="FILTROS.CONDICIONALES.esJuzgadoMixto" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3">
                            <div class="form-group">
                                <h6>Juzgado</h6>
                                <C001Area 
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioTipoJuzgado" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="FILTROS.JUZGADO.ID" 
                                    :parametros="FILTROS.JUZGADO.parametros" 
                                    :valorDefinido="FILTROS.JUZGADO.valorDefinido" 
                                    :key="FILTROS.JUZGADO.KEY + FILTROS.JUZGADO.contRender"></C001Area>
                            </div>
                        </div>
                        <!-- FILTRO DE MATERIA -->
                        <div :class="[(FILTROS.CONDICIONALES.esJuzgadoMixto) 
                            ? 'col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3' 
                            : 'col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3']">
                            <div class="form-group">
                                <h6>Tipo de documento</h6>
                                <C004TiposDocumento 
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioTipoDocumento" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="FILTROS.TIPO_DOCUMENTO.ID" 
                                    :parametros="FILTROS.TIPO_DOCUMENTO.parametros" 
                                    :valorDefinido="FILTROS.TIPO_DOCUMENTO.valorDefinido" 
                                    :key="FILTROS.TIPO_DOCUMENTO.KEY + FILTROS.TIPO_DOCUMENTO.contRender"></C004TiposDocumento>
                            </div>
                        </div>
                        <!-- FILTRO CONSECUTIVO (NUMERO DE EXPEDIENTE) -->
                        <div :class="[(FILTROS.CONDICIONALES.esJuzgadoMixto) 
                            ? 'col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-3 filtros' 
                            : 'col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3 filtros']">
                            <div class="form-group">
                                <h6>Consecutivo</h6>
                                <div class="input-group">
                                    <div class="input-group-append">
                                        <div class="input-group-text"><i class="fa fa-folder"></i></div>
                                    </div>
                                    <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="FILTROS.numeroExpediente" v-mask="'####/####'" placeholder="####/####">
                                </div>
                            </div>
                        </div>
                        <!-- NUMERO EXTRA -->
                        <div v-if="FILTROS.CONDICIONALES.mostrarNumeroExtra" class="col-xs-1 col-sm-1 col-md-1 col-lg-1 pr-4 pt-1 mt-3 filtros">
                            <div class="form-group">
                                <h6>Numero</h6>
                                <div class="input-group">
                                    <div class="input-group-append">
                                        <div class="input-group-text"><i class="fas fa-hashtag"></i></div>
                                    </div>
                                    <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="FILTROS.TIPO_DOCUMENTO.numeroExtra" v-mask="'##'" placeholder="##">
                                </div>
                            </div>
                        </div>
                        <!-- ACCIONES -->
                        <div :class="[(FILTROS.CONDICIONALES.esJuzgadoMixto) 
                            ? 'col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 align-self-end filtros'
                            : 'col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3 align-self-end filtros']">
                            <div class="form-group d-flex align-items-center">
                                <button type="button" @click="obtenerInformacionDeExpediente" class="btn-sm btn btn-light"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                <i v-if="FILTROS.CONDICIONALES.seEncontroExpediente && FILTROS.CONDICIONALES.seRealizoBusquedaExpediente" style="font-size: 2em;" class="fas fa-check-circle text-success ml-3"></i>
                                <i v-if="!FILTROS.CONDICIONALES.seEncontroExpediente && FILTROS.CONDICIONALES.seRealizoBusquedaExpediente" style="font-size: 2em;" class="fas fa-times-circle text-danger ml-3"></i>
                            </div>
                        </div>
                    </div>
                    <!-- FIN SECCION FILTROS DE EXPEDIENTE -->
                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(51, 51, 51); margin-top:9px; margin-bottom:2em;"/>
                    <!-- SECCION DATOS DEL TIPO DE CEDULA -->
                    <div v-if="this.FILTROS.CONDICIONALES.seEncontroExpediente" id="paso-datos-cedula-notificar">
                        <div :class="[(DATOS_CEDULA.habilitada) ? 'row no-gutters' : 'row no-gutters seccion-deshabilitada']">
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1 d-flex align-items-center">
                                <i :class="[(DATOS_CEDULA.seccionEstaTerminada) ? 'fas fa-check-square text-success' : 'far fa-square']" style="font-size: 2em; margin-right: 0.5em;"></i>
                                <h4 class="mt-1">Datos del tipo de cédula</h4>
                            </div>
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-4 pt-1">
                                 <div class="d-flex">
                                    <button type="button" @click="DATOS_CEDULA.visible = !DATOS_CEDULA.visible" class="btn-sm btn btn-light">
                                        <i :class="[(DATOS_CEDULA.visible) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (DATOS_CEDULA.visible) ? 'Ocultar' : 'Mostrar' }} seccion
                                    </button>
                                    <button type="button" @click="guardarInformacionSeccionDatosDeCedula" class="btn-sm btn btn-info ml-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                 </div>
                            </div>
                         </div>
                         <transition name="fade">
                             <div v-show="DATOS_CEDULA.visible" class="row no-gutters contenedor-formularios mt-3">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 mt-1">
                                    <div class="form-inline">
                                        <h6 class="mr-3">
                                            <i @click="DATOS_CEDULA.esUrgente = !DATOS_CEDULA.esUrgente" 
                                                :class="(!DATOS_CEDULA.esUrgente) ? 'far fa-square mt-2' : 'fas fa-check-square mt-2'"
                                                style="cursor: pointer; font-size: 1.1em;"></i>&nbsp;&nbsp;Cédula de carácter urgente
                                        </h6>
                                        <i :class="(!DATOS_CEDULA.esUrgente) ? 'fas fa-user-clock' : 'fas fa-shipping-fast'" style="font-size: 1.1em;"></i>
                                    </div>
                                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:1em;"/>
                                </div>
                                <!-- TIPO DE JURISDICCION -->
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>Área encargada *</h6>
                                        <C003Jurisdicciones 
                                            class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoDeJurisdiccion" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="DATOS_CEDULA.JURISDICCIONES.ID" 
                                            :parametros="DATOS_CEDULA.JURISDICCIONES.parametros" 
                                            :valorDefinido="DATOS_CEDULA.JURISDICCIONES.valorDefinido" 
                                            :key="DATOS_CEDULA.JURISDICCIONES.KEY + DATOS_CEDULA.JURISDICCIONES.contRender"></C003Jurisdicciones>
                                    </div>
                                </div>
                                <!-- TIPO DE CEDULA -->
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>Tipo de cédula *</h6>
                                        <C002TiposCedula 
                                            class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoDeCedula" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="DATOS_CEDULA.TIPO_CEDULA.ID" 
                                            :parametros="DATOS_CEDULA.TIPO_CEDULA.parametros" 
                                            :valorDefinido="DATOS_CEDULA.TIPO_CEDULA.valorDefinido" 
                                            :key="DATOS_CEDULA.TIPO_CEDULA.KEY + DATOS_CEDULA.TIPO_CEDULA.contRender"></C002TiposCedula>
                                    </div>
                                </div>
                                <!-- TIPO DE AUDIENCIA -->
                                <div v-if="mostrarOpcionTipoDeAudiencia" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>Tipo de Audiencia</h6>
                                        <C024TipoAudiencia 
                                            class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoDeAudiencia" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="DATOS_CEDULA.TIPO_AUDIENCIA.ID" 
                                            :parametros="DATOS_CEDULA.TIPO_AUDIENCIA.parametros" 
                                            :valorDefinido="DATOS_CEDULA.TIPO_AUDIENCIA.valorDefinido" 
                                            :key="DATOS_CEDULA.TIPO_AUDIENCIA.KEY + DATOS_CEDULA.TIPO_AUDIENCIA.contRender"></C024TipoAudiencia>
                                    </div>
                                </div>
                                <!-- FECHA DE SENTENCIA -->
                                <div v-if="mostrarOpcionesDeSentencias" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>Fecha de dictado de sentencia</h6>
                                        <input type="date" class="form-control" v-model="DATOS_CEDULA.fechaDeDictadoDeSentencia"/>
                                    </div>
                                </div>
                                <!-- ES ORDEN DE PROTECCION -->
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>¿Orden de protección?*</h6>
                                        <CCatalogoGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioOpcionOrdenDeProteccion" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="DATOS_CEDULA.ORDEN_PROTECCION.ID" 
                                            :valorDefinido="DATOS_CEDULA.ORDEN_PROTECCION.valorDefinido"
                                            :textoOpcionesSingular="DATOS_CEDULA.ORDEN_PROTECCION.DESCRIPCION_S"
                                            :textoOpcionesPlural="DATOS_CEDULA.ORDEN_PROTECCION.DESCRIPCION_P"
                                            :elementosCatalogo="DATOS_CEDULA.ORDEN_PROTECCION.LISTA"
                                            :key="DATOS_CEDULA.ORDEN_PROTECCION.KEY + DATOS_CEDULA.ORDEN_PROTECCION.contRender"></CCatalogoGenerico>
                                    </div>
                                </div>
                                <!-- NUMERO DE FOJAS -->
                                <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>#Fojas</h6>
                                        <input type="text" class="form-control" title="Número de fojas"  placeholder="0" v-model="DATOS_CEDULA.numeroFojas"/>
                                    </div>
                                </div>
                                <!-- DIAS DE TERMINO -->
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>Días de término</h6>
                                        <input type="text" class="form-control" title="Número de fojas"  placeholder="0" v-model="DATOS_CEDULA.diasDeTermino"/>
                                    </div>
                                </div>
                                <!-- NUMERO ORDEN DE PROTECCION -->
                                <div v-if="DATOS_CEDULA.ORDEN_PROTECCION.valorDefinido == 1" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-1">
                                    <div class="form-group">
                                        <h6>numero de orden de protección</h6>
                                        <input type="text" class="form-control" title="Número de fojas"  placeholder="0" v-model="DATOS_CEDULA.numeroOrdenProteccion"/>
                                    </div>
                                </div>
                             </div>
                         </transition>
                    </div>
                    <!-- FIN SECCION DATOS DEL TIPO DE CEDULA -->
                    <!-- SECCION PERSONA A NOTIFICAR -->
                    <div v-if="this.FILTROS.CONDICIONALES.seEncontroExpediente" id="paso-persona-notificar" :class="[(DATOS_CEDULA.visible) ? 'espacio-entre-secciones' : 'mt-4']">
                         <div :class="[(PERSONA_NOTIFICAR.habilitada) ? 'row no-gutters' : 'row no-gutters seccion-deshabilitada']">
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1 d-flex align-items-center">
                                <i :class="[(PERSONA_NOTIFICAR.seccionEstaTerminada) ? 'fas fa-check-square text-success' : 'far fa-square']" style="font-size: 2em; margin-right: 0.5em;"></i>
                                <h4 class="mt-1">Persona a notificar</h4>
                            </div>
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-4 pt-1">
                                <div class="d-flex">
                                    <button type="button" @click="PERSONA_NOTIFICAR.visible = !PERSONA_NOTIFICAR.visible" class="btn-sm btn btn-light">
                                        <i :class="[(PERSONA_NOTIFICAR.visible) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (PERSONA_NOTIFICAR.visible) ? 'Ocultar' : 'Mostrar' }} seccion
                                    </button>
                                    <button type="button" class="btn-sm btn btn-info ml-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                </div>
                            </div>
                         </div>
                         <transition name="fade">
                            <div v-show="PERSONA_NOTIFICAR.visible" class="row no-gutters contenedor-formularios mt-3">
                                <!-- FILTRO TIPO DE PERSONA -->
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1">
                                    <div class="form-group">
                                        <h6>Tipo de persona a notificar *</h6>
                                        <CCatalogoGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioTipoDePersonaANotificar" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="PERSONA_NOTIFICAR.TIPOS_PERSONA.ID" 
                                            :valorDefinido="PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido"
                                            :textoOpcionesSingular="PERSONA_NOTIFICAR.TIPOS_PERSONA.DESCRIPCION_S"
                                            :textoOpcionesPlural="PERSONA_NOTIFICAR.TIPOS_PERSONA.DESCRIPCION_P"
                                            :elementosCatalogo="PERSONA_NOTIFICAR.TIPOS_PERSONA.LISTA"
                                            :key="PERSONA_NOTIFICAR.TIPOS_PERSONA.KEY + PERSONA_NOTIFICAR.TIPOS_PERSONA.contRender"></CCatalogoGenerico>
                                    </div>
                                </div>
                                <!-- FILTRO SE NOTIFICA EN JUZGADO -->
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1">
                                    <div class="form-group">
                                        <h6>¿Se notifica en juzgado? *</h6>
                                        <CCatalogoGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioSeNotificaEnJuzgado" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="PERSONA_NOTIFICAR.TIPOS_RESULTADO.ID" 
                                            :valorDefinido="PERSONA_NOTIFICAR.TIPOS_RESULTADO.valorDefinido"
                                            :textoOpcionesSingular="PERSONA_NOTIFICAR.TIPOS_RESULTADO.DESCRIPCION_S"
                                            :textoOpcionesPlural="PERSONA_NOTIFICAR.TIPOS_RESULTADO.DESCRIPCION_P"
                                            :elementosCatalogo="PERSONA_NOTIFICAR.TIPOS_RESULTADO.LISTA"
                                            :key="PERSONA_NOTIFICAR.TIPOS_RESULTADO.KEY + PERSONA_NOTIFICAR.TIPOS_RESULTADO.contRender"></CCatalogoGenerico>
                                    </div>
                                </div>
                                <!-- FILTRO SE NOTIFICA EN JUZGADO -->
                                <div v-if="mostrarOpcionEsPorEstrado" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1">
                                    <div class="form-group">
                                        <h6>¿Es de estrado?</h6>
                                        <CCatalogoGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="evtCambioEsPorEstrados" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.ID" 
                                            :valorDefinido="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido"
                                            :textoOpcionesSingular="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.DESCRIPCION_S"
                                            :textoOpcionesPlural="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.DESCRIPCION_P"
                                            :elementosCatalogo="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.LISTA"
                                            :key="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.KEY + PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.contRender"></CCatalogoGenerico>
                                    </div>
                                </div>
                                <!-- TIPO DE FORMULARIO PARTE-->
                                <div v-if="this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido == 3" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1">
                                <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                <div class="text-center">
                                        <h4>[ <strong>PARTE A NOTIFICAR</strong> ]</h4>
                                        <h5 style="color: rgb(190, 190, 190); margin-top: -5px;"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Selecciona un de las partes del listado</h5>
                                    </div>
                                    <!-- TABLA PARTES -->
                                    <div v-show="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido != 1" class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                        <table
                                            class="table table-light table-hover"
                                            :id="PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID"              
                                            data-toggle="table"
                                            data-pagination="true"
                                            data-undefined-text="Sin información"
                                            data-maintain-selected="true"  
                                            data-page-size = "5"
                                            data-page-list="[3,5,10,20]"
                                            data-click-to-select="false"
                                            data-show-toggle="false"
                                            data-show-pagination-switch="true"
                                            data-search="true">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th data-halign="center" data-width="50" data-align="center" data-field="NombreParteSTR" data-sortable="true">
                                                        Nombre
                                                    </th>
                                                    <th data-halign="center" data-width="20" data-align="center" data-field="DatosGenerales.TipoPersona.Nombre" data-sortable="true">
                                                        Tipo de persona
                                                    </th>
                                                    <th data-halign="center" data-width="20" data-align="center" data-field="TipoPersonalidad.Nombre" data-sortable="true">
                                                        Tipo personalidad
                                                    </th>
                                                    <th data-events="operateEvents" data-width="10" :data-formatter="this.obtenerHTMLAccionesPartes()" data-halign="center" data-align="center">
                                                        
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div v-show="PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido == 1" class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                        <table
                                            class="table table-light table-hover"
                                            :id="PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID_ESTRADOS"              
                                            data-toggle="table"
                                            data-pagination="true"
                                            data-undefined-text="Sin información"
                                            data-maintain-selected="true"  
                                            data-page-size = "5"
                                            data-page-list="[3,5,10,20]"
                                            data-click-to-select="false"
                                            data-show-toggle="false"
                                            data-show-pagination-switch="true"
                                            data-search="true">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th  data-halign="center" data-width="10" data-align="center" data-checkbox="true"></th>
                                                    <th data-halign="center" data-width="50" data-align="center" data-field="Nombre" data-sortable="true">
                                                        Nombre
                                                    </th>
                                                    <th data-halign="center" data-width="20" data-align="center" data-field="TipoPersona" data-sortable="true">
                                                        Tipo de persona
                                                    </th>
                                                    <th data-halign="center" data-width="20" data-align="center" data-field="TipoPersonalidad" data-sortable="true">
                                                        Tipo personalidad
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <!-- FIN TIPO DE FROMULARIO PARTE -->
                                <!-- TIPO DE FORMULARIO PERSONA FISICA -->
                                <div v-if="this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido == 1" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1">
                                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                    <div class="text-center">
                                        <h4>[ <strong>PERSONA FISICA A NOTIFICAR</strong> ]</h4>
                                        <h5 style="color: rgb(190, 190, 190); margin-top: -5px;"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Ingresa los datos de la persona fisica</h5>
                                    </div>
                                    <!-- CAMPOS PERSONA FISICA-->
                                    <div class="row no-gutters mt-3">
                                        <!-- NOMBRE -->
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Nombre *</h6>
                                                <input type="text" class="form-control" title="NOMBRE"  placeholder="Nombre" v-model="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.nombre"/>
                                            </div>
                                        </div>
                                        <!-- APELLIDO PATERNO -->
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Apellido paterno *</h6>
                                                <input type="text" class="form-control" title="APELLIDO PATERNO"  placeholder="Apellido" v-model="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.apellPaterno"/>
                                            </div>
                                        </div>
                                        <!-- APELLIDO MATERNO -->
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Apellido materno</h6>
                                                <input type="text" class="form-control" title="APELLIDO MATERNO"  placeholder="Apellido" v-model="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.apellMaterno"/>
                                            </div>
                                        </div>
                                        <!-- TIPO DE PERSONALIDAD -->
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Tipo Personalidad</h6>
                                                <C029TiposPersonalidades 
                                                    class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioTipoPersonalidad" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.ID" 
                                                    :parametros="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.parametros" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.valorDefinido" 
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.KEY + PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.contRender"></C029TiposPersonalidades>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- FIN TIPO DE FORMULARIO PERSONA FISICA -->
                                <!-- TIPO DE FORMULARIO PERSONA MORAL -->
                                <div v-if="this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido == 2" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1">
                                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                    <div class="text-center">
                                        <h4>[ <strong>PERSONA MORAL A NOTIFICAR</strong> ]</h4>
                                        <h5 style="color: rgb(190, 190, 190); margin-top: -5px;"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Ingresa los datos de la persona moral o selecciona una del catalogo</h5>
                                    </div>
                                    <!-- CAMPOS PERSONA MORAL-->
                                    <div class="row no-gutters mt-3">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-1">
                                            <h6>
                                                <i @click="evtOpcionDesdeCatalogoPersonaMoral" 
                                                    :class="(!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo) ? 'far fa-square' : 'fas fa-check-square'"
                                                    style="cursor: pointer; font-size: 1.1em;"></i>&nbsp;&nbsp;Agregar desde catalogo
                                            </h6>
                                        </div>
                                         <!-- NOMBRE PERSONA MORAL -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Nombre</h6>
                                                <input type="text" class="form-control" title="NOMBRE"  placeholder="Nombre" v-model="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.nombre"/>
                                            </div>
                                        </div>
                                        <!-- TIPO DE PERSONALIDAD -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Tipo Personalidad</h6>
                                                <C029TiposPersonalidades 
                                                    class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioTipoPersonalidad" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.ID" 
                                                    :parametros="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.parametros" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.valorDefinido" 
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.KEY + PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.contRender"></C029TiposPersonalidades>
                                            </div>
                                        </div>
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-1">
                                            <hr v-if="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario" style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                            <h6>
                                                <i @click="evtOpcionAgregarRepersentantePorFormulario()" 
                                                    :class="(!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario) ? 'far fa-square' : 'fas fa-check-square'"
                                                    style="cursor: pointer; font-size: 1.1em;"></i>&nbsp;&nbsp;Agregar representante legal
                                            </h6>
                                        </div>
                                        <!-- NOMBRE -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Nombre *</h6>
                                                <input type="text" class="form-control" title="NOMBRE"  placeholder="Nombre" v-model="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre"/>
                                            </div>
                                        </div>
                                        <!-- APELLIDO PATERNO -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Apellido paterno *</h6>
                                                <input type="text" class="form-control" title="APELLIDO PATERNO"  placeholder="Apellido" v-model="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno"/>
                                            </div>
                                        </div>
                                        <!-- APELLIDO MATERNO -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Apellido materno</h6>
                                                <input type="text" class="form-control" title="APELLIDO MATERNO"  placeholder="Apellido" v-model="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno"/>
                                            </div>
                                        </div>
                                        <div v-if="mostrarOpcionAgregarRepresentanteEnLista" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-1 align-self-end">
                                            <div class="form-group">
                                                <button type="button" @click="agregarReprentanteAListadoPorFormulario" class="btn-sm btn btn-info"><i class="fas fa-plus-square"></i>&nbsp;&nbsp;Agregar</button>
                                            </div>
                                        </div>
                                        <!-- TABLA DE REPRESENTANTES LEGALES EMPRESA MORAL POR FORMULARIO -->
                                        <div v-show="this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario && campoEsValido({ campoAValidar: PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista })" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-1">
                                            <div class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                                <table
                                                    class="table table-light table-hover"
                                                    :id="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.ID_TABLA"              
                                                    data-toggle="table"
                                                    data-pagination="true"
                                                    data-undefined-text="Sin información"
                                                    data-maintain-selected="true"  
                                                    data-page-size = "5"
                                                    data-page-list="[3,5,10,20]"
                                                    data-click-to-select="false"
                                                    data-show-toggle="false"
                                                    data-show-pagination-switch="true"
                                                    data-search="true">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th data-halign="center" data-width="5" data-align="center" data-field="id" data-sortable="true">
                                                                #
                                                            </th>
                                                            <th data-halign="center" data-width="30" data-align="center" data-field="nombre" data-sortable="true">
                                                                Nombre
                                                            </th>
                                                            <th data-halign="center" data-width="30" data-align="center" data-field="apellidoPaterno" data-sortable="true">
                                                                Apellido Paterno
                                                            </th>
                                                            <th data-halign="center" data-width="30" data-align="center" data-field="apellidoMaterno" data-sortable="true">
                                                                Apellido Materno
                                                            </th>
                                                            <th data-events="operateEvents" data-width="5" :data-formatter="this.obtenerHTMLAccionesRepresentantesLegalesFormulario()" data-halign="center" data-align="center">
                                                                
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-1">
                                            <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                        </div>
                                        <!-- ACCION GUARDAR PERSONA MORAL -->
                                        <div v-if="!PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 d-flex justify-content-end">
                                            <button type="button" @click="PERSONA_NOTIFICAR.seccionEstaTerminada = !PERSONA_NOTIFICAR.seccionEstaTerminada" class="btn-sm btn btn-info"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar persona moral</button>
                                        </div>
                                        <!-- FILTRO EMPRESAS -->
                                        <div v-if="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                            <div class="form-group">
                                                <h6>Empresa o institucion *</h6>
                                                <C007Empresas 
                                                    class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioEmpresa" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.ID" 
                                                    :parametros="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.parametros" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.valorDefinido" 
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.KEY + PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.contRender"></C007Empresas>
                                            </div>
                                        </div>
                                        <!-- FILTRO SE NOTIFICA EN JUZGADO -->
                                        <div v-if="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                            <div class="form-group">
                                                <h6>Representante legal</h6>
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioTipoRepresentante" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.ID" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido"
                                                    :textoOpcionesSingular="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.DESCRIPCION_S"
                                                    :textoOpcionesPlural="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.DESCRIPCION_P"
                                                    :elementosCatalogo="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.LISTA"
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.KEY + PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.contRender"></CCatalogoGenerico>
                                            </div>
                                        </div>
                                        <!-- FORMA DEL REPRESENTANTE -->
                                        <div v-if="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && !mostrarRepresentantesDeEmpresaCatalogo" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                            <div class="form-group">
                                                <h6>Forma del representante legal</h6>
                                                <input type="text" class="form-control" title="NOMBRE"  placeholder="Nombre" v-model="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.formaRepresentanteLegal"/>
                                            </div>
                                        </div>
                                        <!-- CATALOGO REPRESENTANTES LEGALES EMPRESA SELECCIONADA -->
                                        <div v-if="mostrarRepresentantesDeEmpresaCatalogo" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1">
                                            <div class="form-group">
                                                <h6>Representante legal</h6>
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioEsPorEstrados" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.ID" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.valorDefinido"
                                                    :textoOpcionesSingular="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.DESCRIPCION_S"
                                                    :textoOpcionesPlural="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.DESCRIPCION_P"
                                                    :elementosCatalogo="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.LISTA"
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.KEY + PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.contRender"></CCatalogoGenerico>
                                            </div>
                                        </div>
                                        <!-- TIPO DE PERSONALIDAD REPRESENTANTE LEGAL EMPRESA SELECCIONADA -->
                                        <div v-if="mostrarRepresentantesDeEmpresaCatalogo" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-4 pt-1 mt-1">
                                            <div class="form-group">
                                                <h6>Tipo Personalidad</h6>
                                                <C029TiposPersonalidades 
                                                    class="p-0 m-0" 
                                                    v-on:valorParaElPadre="evtCambioTipoPersonalidad" 
                                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                    :idDelInput="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.TIPO_PERSONALIDAD.ID" 
                                                    :parametros="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.TIPO_PERSONALIDAD.parametros" 
                                                    :valorDefinido="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.TIPO_PERSONALIDAD.valorDefinido" 
                                                    :key="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.TIPO_PERSONALIDAD.KEY + PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.TIPO_PERSONALIDAD.contRender"></C029TiposPersonalidades>
                                            </div>
                                        </div>
                                        <!-- TABLA PARTES -->
                                        <div v-if="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo &&
                                                   (PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.seleccionado != null)" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-3">
                                            <div class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                                <table
                                                    class="table table-light table-hover"
                                                    :id="PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.ID_TABLA_DOMICILIOS"              
                                                    data-toggle="table"
                                                    data-pagination="true"
                                                    data-undefined-text="Sin información"
                                                    data-maintain-selected="true"  
                                                    data-page-size = "5"
                                                    data-page-list="[3,5,10,20]"
                                                    data-click-to-select="false"
                                                    data-show-toggle="false"
                                                    data-show-pagination-switch="true"
                                                    data-search="true">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th data-halign="center" data-width="5" data-align="center" data-field="id" data-sortable="true">
                                                                #
                                                            </th>
                                                            <th data-halign="center" data-width="30" data-align="center" data-field="calle" data-sortable="true">
                                                                Calle
                                                            </th>
                                                            <th data-halign="center" data-width="5" data-align="center" data-field="numero" data-sortable="true">
                                                                Numero
                                                            </th>
                                                            <th data-halign="center" data-width="15" data-align="center" data-field="fraccionamiento" data-sortable="true">
                                                                Fraccionamiento
                                                            </th>
                                                            <th data-halign="center" data-width="5" data-align="center" data-field="codifoPostal" data-sortable="true">
                                                                Codigo Postal
                                                            </th>
                                                            <th data-halign="center" data-width="15" data-align="center" data-field="municipio" data-sortable="true">
                                                                Municipio
                                                            </th>
                                                            <th data-halign="center" data-width="15" data-align="center" data-field="referencias" data-sortable="true">
                                                                Referencias
                                                            </th>
                                                            <th data-events="operateEvents" data-width="10" :data-formatter="this.obtenerHTMLAccionesDomiciliosEmpresas()" data-halign="center" data-align="center">
                                                                
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- FIN TIPO DE FROMULARIO PERSONA MORAL -->
                            </div>
                        </transition>
                    </div>
                    <!-- FIN SECCION PERSONA A NOTIFICAR  -->
                    <!-- SECCION DOMICILIO DE NOTIFICACION -->
                    <div v-if="mostrarSeccionDeDomicilios" id="paso-domicilio-notificar" :class="[(PERSONA_NOTIFICAR.visible) ? 'espacio-entre-secciones' : 'mt-4']">
                        <div :class="[(DOMICILIO_CEDULA.habilitada) ? 'row no-gutters' : 'row no-gutters seccion-deshabilitada']">
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1 d-flex align-items-center">
                                <i :class="[(DOMICILIO_CEDULA.seccionEstaTerminada) ? 'fas fa-check-square text-success' : 'far fa-square']" style="font-size: 2em; margin-right: 0.5em;"></i>
                                <h4 class="mt-1">Domicilio de notificacion</h4>
                            </div>
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-4 pt-1">
                                 <div class="d-flex">
                                    <button type="button" @click="DOMICILIO_CEDULA.visible = !DOMICILIO_CEDULA.visible" class="btn-sm btn btn-light">
                                        <i :class="[(DOMICILIO_CEDULA.visible) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (DOMICILIO_CEDULA.visible) ? 'Ocultar' : 'Mostrar' }} seccion
                                    </button>
                                    <button type="button" class="btn-sm btn btn-info ml-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                 </div>
                            </div>
                         </div>
                         <transition name="fade">
                             <div v-show="DOMICILIO_CEDULA.visible" class="row no-gutters contenedor-formularios mt-3">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 mt-1">
                                    <div class="form-group">
                                        <CFormularioDomicilio 
                                            :ref="DOMICILIO_CEDULA.REF"
                                            :idFormulario="DOMICILIO_CEDULA.ID" 
                                            :valorDefinidoFraccionamientos="DOMICILIO_CEDULA.valorDefinidoParaFraccionamiento"
                                            :contadorRenderCatalogo="DOMICILIO_CEDULA.contRender"
                                            :valorDefinidoMunicipios="DOMICILIO_CEDULA.valorDefinidoParaMunicipio"
                                            :conMensajeProcesoAgregar="DOMICILIO_CEDULA.conMensajesEnProcesos"
                                            :contadorRenderCatalogoMunicipio="DOMICILIO_CEDULA.contRenderMunicipio"
                                            :conSeleccionUnicaDeDomicilio="DOMICILIO_CEDULA.conSeleccionUnicaDeDomicilio"
                                            :herramientas="DOMICILIO_CEDULA.opcionesParaMapa"  
                                            v-on:domicilioPrincipal="evtObtenerDomicilioPrincipal"                                                                                                                              
                                            v-on:obtenerContRenderC="DOMICILIO_CEDULA.contRender = $event"
                                            v-on:obtenerValorDefinidoCF="DOMICILIO_CEDULA.valorDefinidoParaFraccionamiento = $event"
                                            v-on:obtenerContRenderCM="DOMICILIO_CEDULA.contRenderMunicipio = $event"
                                            v-on:obtenerValorDefinidoCM="DOMICILIO_CEDULA.valorDefinidoParaMunicipio = $event"
                                            v-on:obtenerListadoDeDomicilios="obtenerListadoDeDomicilios"
                                            :key="DOMICILIO_CEDULA.KEY + DOMICILIO_CEDULA.contRender"></CFormularioDomicilio>    
                                    </div>
                                </div>
                             </div>
                         </transition>
                    </div>
                    <!-- FIN SECCION DOMICILIO DE NOTIFICACION -->
                    <!-- SECCION DE ACUERDOS -->
                    <div v-if="this.FILTROS.CONDICIONALES.seEncontroExpediente" id="paso-acuerdos-notificar" :class="[(DOMICILIO_CEDULA.visible) ? 'espacio-entre-secciones' : 'mt-4']">
                        <div :class="[(ACUERDOS_CEDULA.habilitada) ? 'row no-gutters' : 'row no-gutters seccion-deshabilitada']">
                            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-1 pt-1 d-flex align-items-center">
                                <i :class="[(ACUERDOS_CEDULA.seccionEstaTerminada) ? 'fas fa-check-square text-success' : 'far fa-square']" style="font-size: 2em; margin-right: 0.5em;"></i>
                                <h4 class="mt-1">Acuerdos de notificacion</h4>
                            </div>
                            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-4 pt-1">
                                 <div class="d-flex">
                                    <button type="button" @click="ACUERDOS_CEDULA.visible = !ACUERDOS_CEDULA.visible" class="btn-sm btn btn-light">
                                        <i :class="[(ACUERDOS_CEDULA.visible) ? 'fas fa-caret-square-down' : 'fas fa-caret-square-up']"></i>&nbsp;&nbsp;{{ (ACUERDOS_CEDULA.visible) ? 'Ocultar' : 'Mostrar' }} seccion
                                    </button>
                                    <button type="button" class="btn-sm btn btn-info ml-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                                 </div>
                            </div>
                         </div>
                         <transition name="fade">
                             <div v-show="ACUERDOS_CEDULA.visible" class="row no-gutters contenedor-formularios mt-3">
                                 <!-- TABLA DE ACUERDOS -->
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 mt-1">
                                    <div class="form-group">
                                        <div class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                            <table
                                                class="table table-light table-hover"
                                                :id="ACUERDOS_CEDULA.TABLA.ID"              
                                                data-toggle="table"
                                                data-pagination="true"
                                                data-undefined-text="Sin información"
                                                data-maintain-selected="true"  
                                                data-page-size = "5"
                                                data-page-list="[3,5,10,20]"
                                                data-click-to-select="false"
                                                data-show-toggle="false"
                                                data-show-pagination-switch="true"
                                                data-search="true">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th  data-halign="center" data-width="10" data-align="center" data-checkbox="true"></th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="id" data-sortable="true">
                                                            Folio
                                                        </th>
                                                        <th data-halign="center" data-width="20" data-align="center" data-field="tipoDeDocumento" data-sortable="true">
                                                            Tipo de documento
                                                        </th>
                                                        <th data-halign="center" data-width="40" data-align="center" data-field="extracto" data-sortable="true">
                                                            Extracto
                                                        </th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="fechaDePublicacion" data-sortable="true">
                                                            Fecha de publicacion
                                                        </th>
                                                        <th data-events="operateEvents" data-width="10" :data-formatter="this.obtenerHTMLAcuerdos()" data-halign="center" data-align="center">
                                                            
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <!-- FIN TABLA DE ACUERDOS -->
                                <!-- ACUERDOS SELECCIONADOS -->
                                <div v-if="this.ACUERDOS_CEDULA.TABLA.seleccionados.length > 0" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 mt-1">
                                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(114, 114, 114); margin-top:9px; margin-bottom:2em;"/>
                                    <div class="form-group">
                                        <div class="text-center">
                                            <h4>[ <strong>ACUERDOS SELECCIONADOS</strong> ]</h4>
                                            <h5 style="color: rgb(190, 190, 190); margin-top: -5px;"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;En caso de que algún acuerdo fije audiencia favor de indicar la fecha.</h5>
                                        </div>
                                        <div class="contenedor-tabla-SINOJ-VCDCV2 table-responsive mt-3" >
                                            <table
                                                class="table table-light table-hover"
                                                :id="ACUERDOS_CEDULA.TABLA.ID_SELECCIONADOS"              
                                                data-toggle="table"
                                                data-pagination="true"
                                                data-undefined-text="Sin información"
                                                data-maintain-selected="true"  
                                                data-page-size = "5"
                                                data-page-list="[3,5,10,20]"
                                                data-click-to-select="false"
                                                data-show-toggle="false"
                                                data-show-pagination-switch="false"
                                                data-editable="true"
                                                data-search="false">
                                                <thead class="thead-dark">
                                                    <tr>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="id" data-sortable="true">
                                                            Folio
                                                        </th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="tipoDeDocumento" data-sortable="true">
                                                            Tipo de documento
                                                        </th>
                                                        <th data-halign="center" data-width="30" data-align="center" data-field="extracto" data-sortable="true">
                                                            Extracto
                                                        </th>
                                                        <th data-halign="center" data-width="10" data-align="center" data-field="fechaDePublicacion" data-sortable="true">
                                                            Fecha de publicacion 
                                                        </th>
                                                        <th data-events="operateEvents" data-width="15" :data-formatter="obtenerValores" data-halign="center" data-align="center">
                                                            
                                                        </th>
                                                        <th data-events="operateEvents" data-width="5" :data-formatter="this.obtenerHTMLAccionesAcuerdosSeleccionados({ radio: true, datetime: false })" data-halign="center" data-align="center">
                                                            
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <!-- FIN ACUERDOS SELECCIONADOS -->
                             </div>
                         </transition>
                    </div>
                    <!-- FIN SECCION DE ACUERDOS -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import sistemas from '@/../static/js/sistemas'  
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'
import router from '@/router/index'
import VueMask from 'v-mask'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import Router from '@/router/index'
import Datepicker from 'vuejs-datepicker'  
import { campoEsValido, manipularVisualizacionModal, esLaMismaCadena } from "../../../Comun/Funciones/validaciones.js"
import { servicioRestPost } from "../../../Comun/ServiciosRest/servicios.js"
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

Vue.use(VueMask);
export default {
    components: {
        C002Materias:            catalogos.PJ.C002Materias,
        C001Area:                catalogos.PJ.C001Area,
        C004TiposDocumento:      catalogos.PJ.C004TipoDocumento,
        CCatalogoGenerico:       sistemas.SINOJ.CCatalogoGenerico,
        C029TiposPersonalidades: catalogos.PJ.C029TipoPersonalidad,
        C007Empresas:            catalogos.SINOJ.C007Empresas,
        C003Jurisdicciones:      catalogos.SINOJ.C003Jurisdicciones,   
        C002TiposCedula:         catalogos.SINOJ.C002TiposCedula,
        C024TipoAudiencia:       catalogos.PJ.C024TipoAudiencia,
        CFormularioDomicilio:    sistemas.SINOJ.CFormularioDomicilio, 
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            enumeraciones,   
            campoEsValido, 
            esLaMismaCadena,
            cedulaDeNotificacion: { 
                CedulaId: -1,
                PersonasANotificar: []
            },
            ID_TIPOS_AUDIENCIA: [ 1, 10 ],
            ID_TIPOS_SENTENCIA: [ 11 ],
            INFORMACION_AREA_USUARIO: {
                NOMBRE_JUZGADO: 'Juzgado primero de lo familiar',
                MATERIA: 'Familiar',
            },
            PASOS: {
                UNO: { activo: true, descripcion: 'Paso 1: Informacion de la notificacion' },
                DOS: { activo: false, descripcion: 'Paso 2: Generacion del archivo' }
            },       
            FILTROS: {
                expedienteObj: null,
                MATERIA: {
                    ID: 'F-MATERIA-CDCV2-SINOJ',
                    KEY: 'K-MATERIA-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: -1,
                    contRender: 0,
                    parametros: { }
                },
                JUZGADO: {
                    ID: 'F-JUZGADO-CDCV2-SINOJ',
                    KEY: 'K-JUZGADO-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: -1,
                    contRender: 0,
                    parametros: { conPartidoJudicial: true, conMaterias: true,
                     Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true }, { MateriaId: 13, Activo: true }],
                     elementosAOmitir: [26,36]
                    }
                },
                TIPO_DOCUMENTO: {
                    ID: 'F-TPDOCUMENTO-CDCV2-SINOJ',
                    KEY: 'K-TPDOCUMENTO-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: 1,
                    contRender: 0,
                    parametros: { soloDocumentosPrincipales: true },
                    numeroExtra: null // solo para los tipos de documento incidente o tercerias
                },
                numeroExpediente: null,
                CONDICIONALES: {
                    esJuzgadoMixto: false,
                    seRealizoBusquedaExpediente: false,
                    seEncontroExpediente: false,
                    mostrarNumeroExtra: false
                }
            },
            DATOS_CEDULA: {
                habilitada: false,
                visible: false,
                seccionEstaTerminada: false,
                JURISDICCIONES: {
                    ID: 'F-JURISDICCIONES-CDCV2-SINOJ',
                    KEY: 'K-JURISDICCIONES-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: 1,
                    contRender: 0,
                    parametros: { conAreasDeJurisdiccion: true }
                },
                TIPO_CEDULA: {
                    ID: 'F-TIPO-CEDULA-CDCV2-SINOJ',
                    KEY: 'K-TIPO-CEDULA-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: -1,
                    contRender: 0,
                    parametros: { conAreasDeJurisdiccion: true }
                },
                ORDEN_PROTECCION: {
                    DESCRIPCION_S: '', // Singular
                    DESCRIPCION_P: '', // Plural
                    LISTA: [ { llave: 1, valor: 'Si' }, { llave: 2, valor: 'No' } ],
                    valorDefinido: 2,
                    ID: 'CEsOrdenDeProteccion-VCDCV2',
                    KEY: 'KEsOrdenDeProteccion-VCDCV2',
                    contRender: 0
                },
                esUrgente: false,
                numeroFojas: null,
                diasDeTermino: null,
                TIPO_AUDIENCIA: {
                    ID: 'F-AUDIENCIA-CDCV2-SINOJ',
                    KEY: 'K-AUDIENCIA-CDCV2-SINOJ',
                    seleccionado: null,
                    valorDefinido: -1,
                    contRender: 0,
                    parametros: { }
                },
                fechaDeDictadoDeSentencia: null,
                numeroOrdenProteccion: null
            },
            PERSONA_NOTIFICAR: {
                habilitada: false,
                visible: false,
                seccionEstaTerminada: false,
                TIPOS_PERSONA: {
                    DESCRIPCION_S: 'Tipo de persona', // Singular
                    DESCRIPCION_P: 'Tipo de personas', // Plural
                    LISTA: [ { llave: 1, valor: 'Persona Física' }, { llave: 2, valor: 'Persona Moral' }, { llave: 3, valor: 'Parte' } ],
                    valorDefinido: 3,
                    ID: 'CTipoDePersona-VCDCV2',
                    KEY: 'KTipoDePersona-VCDCV2',
                    contRender: 0
                },
                TIPOS_RESULTADO: {
                    DESCRIPCION_S: '', // Singular
                    DESCRIPCION_P: '', // Plural
                    LISTA: [ { llave: 1, valor: 'Si' }, { llave: 2, valor: 'No' } ],
                    valorDefinido: 2,
                    ID: 'CTipoSeNotificaEnJuzgado-VCDCV2',
                    KEY: 'KTipoSeNotificaEnJuzgado-VCDCV2',
                    contRender: 0
                },
                TIPOS_NOT_EN_JUZGADO: {
                    DESCRIPCION_S: '', // Singular
                    DESCRIPCION_P: '', // Plural
                    LISTA: [ { llave: 1, valor: 'Si' }, { llave: 2, valor: 'No' } ],
                    valorDefinido: 2,
                    ID: 'CTipoEsPorEstrado-VCDCV2',
                    KEY: 'KTipoEsPorEstrado-VCDCV2',
                    contRender: 0
                },
                FORMULARIOS: {
                    PARTES: {
                        ID: 'ID-TablaPartes-VCDCV2',
                        ID_ESTRADOS: 'ID-TablaPartes-ESTRADOS-VCDCV2',
                        listaOriginal: [],
                        listaParaTabla: [],
                        seleccionado: null,
                        seleccionados: []
                    },
                    FISICA: {
                        nombre: null,
                        apellPaterno: null,
                        apellMaterno: null,
                        TIPO_PERSONALIDAD: {
                            ID: 'F-PERSONALIDAD-CDCV2-SINOJ',
                            KEY: 'K-PERSONALIDAD-CDCV2-SINOJ',
                            seleccionado: null,
                            valorDefinido: -1,
                            contRender: 0,
                            parametros: { }
                        }
                    },
                    MORAL: {
                        agregarDesdeCatalogo: true,
                        nombre: null,
                        TIPO_PERSONALIDAD: {
                            ID: 'F-PERSONALIDAD-M-CDCV2-SINOJ',
                            KEY: 'K-PERSONALIDAD-M-CDCV2-SINOJ',
                            seleccionado: null,
                            valorDefinido: -1,
                            contRender: 0,
                            parametros: { }
                        },
                        REPRESENTANTE_LEGAL_FORMULARIO: {
                            nombre: null,
                            apellPaterno: null,
                            apellMaterno: null,
                            mostrarFormulario: false,
                            ID_TABLA: 'ID-TABLA-REPRESENTANTES-PERSONA-MORAL-CDCV2-SINOJ',
                            lista: [],
                            contadorRepresentantesAgregados: 0
                        },
                        EMPRESAS: {
                            ID: 'F-EMPRESAS-CDCV2-SINOJ',
                            ID_TABLA_DOMICILIOS: 'ID-TABLA-DOMICILIOS-EMPRESAS-CDCV2-SINOJ', 
                            KEY: 'K-EMPRESAS-CDCV2-SINOJ',
                            seleccionado: null,
                            valorDefinido: -1,
                            contRender: 0,
                            parametros: { conRepresentantesLegales: true,conDomicilios: true,EsParaDireccion: false },
                            domicilios: [],
                            REPRESENTANTE_LEGAL: {
                                DESCRIPCION_S: 'una opcion', // Singular
                                DESCRIPCION_P: 'las opciones', // Plural
                                LISTA: [],
                                valorDefinido: 1,
                                ID: 'CTiporRepresntanteEmpresa-catalogo-VCDCV2',
                                KEY: 'KTiporRepresntanteEmpresa-catalogo-VCDCV2',
                                contRender: 0
                            },
                            TIPO_PERSONALIDAD: {
                                ID: 'F-PERSONALIDAD-REPRESENTANTE-EMPRESA-CDCV2-SINOJ',
                                KEY: 'K-PERSONALIDAD-REPRESENTANTE-EMPRESA-CDCV2-SINOJ',
                                seleccionado: null,
                                valorDefinido: -1,
                                contRender: 0,
                                parametros: { }
                            }
                        },
                        REPRESENTANTE_LEGAL: {
                            DESCRIPCION_S: 'una opcion', // Singular
                            DESCRIPCION_P: 'las opciones', // Plural
                            LISTA: [],
                            valorDefinido: 1,
                            ID: 'CTiporRepresntanteEmpresa-VCDCV2',
                            KEY: 'KTiporRepresntanteEmpresa-VCDCV2',
                            contRender: 0
                        },
                        formaRepresentanteLegal: null
                    }
                }
            },
            DOMICILIO_CEDULA: {
                habilitada: false,
                visible: false,
                seccionEstaTerminada: false,
                ID: 'ID-CDomicilios-VCDCV2-SINOJ',
                REF: 'REF-CDomicilios-VCDCV2-SINOJ',
                KEY: 'KEY-CDomicilios-VCDCV2-SINOJ',
                valorDefinidoParaFraccionamiento: -1,
                valorDefinidoParaMunicipio: -1,
                contRender: 0,
                contRenderMunicipio: 0,
                conSeleccionUnicaDeDomicilio: true,
                opcionesParaMapa: { domicilioConPuntero: false, ubicarDomicilioEnMapa: true },
                conMensajesEnProcesos: false
            },
            ACUERDOS_CEDULA: {
                habilitada: false,
                visible: false,
                seccionEstaTerminada: false,
                TABLA: {
                    ID: 'ID-TABLA-ACUERDOS-VCDCV2-SINOJ',
                    ID_SELECCIONADOS: 'ID-TABLA-ACUERDOS-SELECCIONADOS-VCDCV2-SINOJ',
                    KEY: 'KEY-TABLA-ACUERDOS-VCDCV2-SINOJ',
                    listaOriginal: [],
                    listaParaTabla: [],
                    seleccionado: null,
                    seleccionados: []
                }
            }
        }
    },
    methods: {
        guardarInformacionSeccionPersonaANotificar: async function({ esParaEdicion = false }) {
            const { TIPOS_PERSONA } = this.PERSONA_NOTIFICAR;
            switch(TIPOS_PERSONA.valorDefinido) {
                case 1: // fisica
                    this.crearPersonaDesdePersonaFisica();
                    break;
                case 2: // moral
                    this.crearPersonaDesdePersonaMoral();
                    break;
                case 3: // parte
                    this.crearPersonaDesdeParte();
                    break;
                default:
                    break;
            }
        },
        crearPersonaDesdeParte: function() {
            
        },
        crearPersonaDesdePersonaFisica: function() {

        },
        crearPersonaDesdePersonaMoral: function() {

        },
        guardarInformacionSeccionDatosDeCedula: async function({ esParaEdicion = false }) {
            const { puedeAvanzar,  mensaje } = this.seccionDatosDeCedulaEstaCompleta();
            this.DATOS_CEDULA.seccionEstaTerminada = puedeAvanzar;
            this.limpiarSeccionDatosDeCedula();
            if(puedeAvanzar) {
                this.DATOS_CEDULA.visible = false;
                const { JURISDICCIONES, TIPO_CEDULA, ORDEN_PROTECCION, TIPO_AUDIENCIA, fechaDeDictadoDeSentencia, numeroFojas, diasDeTermino } = this.DATOS_CEDULA;
                // se actualiza el objeto de la jusrisdiccion de la cedula
                this.cedulaDeNotificacion.Jurisdiccion = {
                    JurisdiccionId: JURISDICCIONES.valorDefinido,
                    Activo: true // dato no relevante solo se asigna para prevenir error rn la conversion por no ser objeto nullable
                }
                // se actualiza el ojeto para el tipo de cedula
                this.cedulaDeNotificacion.TipoCedula = {
                    TipoCedulaId: TIPO_CEDULA.valorDefinido,
                    Activo: true // dato no relevante solo se asigna para prevenir error rn la conversion por no ser objeto nullable
                }
                if(this.mostrarOpcionTipoDeAudiencia) {
                    // se actualiza el ojeto para el tipo de audiencia
                    this.cedulaDeNotificacion.TipoAudiencia = {
                        TipoAudienciaId: TIPO_AUDIENCIA.valorDefinido,
                        Activo: true // dato no relevante solo se asigna para prevenir error rn la conversion por no ser objeto nullable
                    };
                }
                if(this.mostrarOpcionesDeSentencias) {
                    this.cedulaDeNotificacion.FechaDeDictadoDeSentencia = fechaDeDictadoDeSentencia;
                }
                this.cedulaDeNotificacion.EsOrdenDeProteccion = (ORDEN_PROTECCION.valorDefinido < 2); // 1 = SI, 2 = NO
                this.cedulaDeNotificacion.NumeroDeFojas = numeroFojas;
                this.cedulaDeNotificacion.DiasDeTermino = diasDeTermino;
            }
            else {
                comun.mensajeDeAlerta(mensaje);
            }
            console.log('cedulaGuardar::',this.cedulaDeNotificacion);
        },
        limpiarSeccionDatosDeCedula: function({ soloCamposObligatorios = true }) {
            if(!soloCamposObligatorios) {
                this.DATOS_CEDULA.seccionEstaTerminada = false;
                this.DATOS_CEDULA.visible              = false;
                this.DATOS_CEDULA.habilitada           = false;
            }
            this.cedulaDeNotificacion.Jurisdiccion              = null;
            this.cedulaDeNotificacion.TipoCedula                = null;
            this.cedulaDeNotificacion.TipoAudiencia             = null;
            this.cedulaDeNotificacion.EsOrdenDeProteccion       = null;
            this.cedulaDeNotificacion.NumeroDeFojas             = null;
            this.cedulaDeNotificacion.DiasDeTermino             = null;
            this.cedulaDeNotificacion.FechaDeDictadoDeSentencia = null;
        },
        seccionDatosDeCedulaEstaCompleta: function() { debugger
            let estatusDeValidacion = { puedeAvanzar: true, mensaje: null };
            const { JURISDICCIONES, TIPO_CEDULA, ORDEN_PROTECCION, TIPO_AUDIENCIA, fechaDeDictadoDeSentencia } = this.DATOS_CEDULA;
            let camposObligatorios = [
                { valor: JURISDICCIONES.valorDefinido, mensaje: 'Area encargada' },
                { valor: TIPO_CEDULA.valorDefinido, mensaje: 'Tipo de cedula' },
                { valor: ORDEN_PROTECCION.valorDefinido, mensaje: 'Orden de proteccion' }
            ];

            if(this.mostrarOpcionTipoDeAudiencia)
                camposObligatorios.push({ valor: TIPO_AUDIENCIA.valorDefinido, mensaje: 'Tipo de audiencia' });

            if(this.mostrarOpcionesDeSentencias) 
                camposObligatorios.push({ valor: fechaDeDictadoDeSentencia, mensaje: 'Tipo de audiencia' });

            for(let i=0; i < camposObligatorios.length; i++) {
                let campoObj = camposObligatorios[i];
                estatusDeValidacion.puedeAvanzar = campoEsValido({ campoAValidar: campoObj.valor });
                if(!estatusDeValidacion.puedeAvanzar) {
                    estatusDeValidacion.mensaje = `Se detectaron campos incorrectos en la seccion "Datos del tipo de cédula"<br>Favor de ingrear informacion valida en [ ${ campoObj.mensaje } ]`;
                    break;
                }
            }
            return estatusDeValidacion;
        },
        obtenerInformacionDeExpediente: async function() {
            this.FILTROS.CONDICIONALES.seRealizoBusquedaExpediente = true;
            const { TIPO_DOCUMENTO, numeroExpediente, JUZGADO, MATERIA } = this.FILTROS;
            const PETICION_API = {
                MateriaId:         campoEsValido({ campoAValidar: MATERIA.valorDefinido}) ? MATERIA.valorDefinido : null,
                AreaId:            campoEsValido({ campoAValidar: JUZGADO.valorDefinido}) ? JUZGADO.valorDefinido : null,
                TipoDeDocumentoId: campoEsValido({ campoAValidar: TIPO_DOCUMENTO.valorDefinido}) ? TIPO_DOCUMENTO.valorDefinido : null,
                NumeroDocumento:   campoEsValido({ campoAValidar: numeroExpediente }) ? numeroExpediente : null,
                NumeroExtra:       campoEsValido({ campoAValidar: TIPO_DOCUMENTO.numeroExtra}) ? TIPO_DOCUMENTO.numeroExtra : null,
                EsPrueba:          false
            };
            const { CON_ERROR, RESPUESTA: { Expediente } }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.SINOJ.sistema.cedulas.creacion.ObtenerDocumento,
                peticionServicio: PETICION_API,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));
            console.log({ Expediente });
            this.FILTROS.expedienteObj = Expediente;
            // se llenan las diferentes secciones que dependen de la informacion del expediente
            if(!CON_ERROR && campoEsValido({ campoAValidar: Expediente })) {
                this.FILTROS.CONDICIONALES.seEncontroExpediente = true;
                const { Personas } = Expediente;
                // se llena la seccion para la seleccion de partes
                if(campoEsValido({ campoAValidar: Personas })) {
                    await Promise.resolve(this.construirTablaDePartes({ partes: Personas }));
                }
                this.inicializarSeccionesDePasoUno({ datosCedula: true, personaANotificar: true, domicilio: true, acuerdos: false});
            }
            else {
                this.FILTROS.CONDICIONALES.seEncontroExpediente = false;
            }
        },
        inicializarSeccionesDePasoUno: function({ datosCedula, personaANotificar, domicilio, acuerdos }) {
            this.DATOS_CEDULA.habilitada      = datosCedula;
            this.DATOS_CEDULA.visible         = datosCedula;
            this.PERSONA_NOTIFICAR.habilitada = personaANotificar;
            this.PERSONA_NOTIFICAR.visible    = personaANotificar;
            this.DOMICILIO_CEDULA.habilitada  = domicilio;
            this.DOMICILIO_CEDULA.visible     = domicilio;
            this.ACUERDOS_CEDULA.habilitada   = acuerdos;
            this.ACUERDOS_CEDULA.visible      = acuerdos;
        },
        construirTablaDePartes: async function({ partes }) {
            const PARTES_FORMATO_TABLA = partes.map(p => { 
                let parteObj = { ...p };
                parteObj.NombreParteSTR = (
                    campoEsValido({ campoAValidar: p.DatosGenerales.Fisica })
                        ? `${ p.DatosGenerales.Fisica.Nombre } ${ p.DatosGenerales.Fisica.ApellidoPaterno } ${ campoEsValido({ campoAValidar: p.DatosGenerales.Fisica.ApellidoMaterno }) ? p.DatosGenerales.Fisica.ApellidoMaterno : '' }`
                        : campoEsValido({ campoAValidar: p.DatosGenerales.Moral }) 
                            ? p.DatosGenerales.Moral.Nombre : 'Sin nombre'
                );
                return parteObj;
            });
            await Promise.resolve(this.inicializarTabla({ elementos: PARTES_FORMATO_TABLA, idTabla: this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID }));
        },
        obtenerDatosDeUsuario: async function() {
            const { CON_ERROR, RESPUESTA: { Usuario } }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.SINOJ.sistema.cedulas.creacion.ObtenerDatosUsuario,
                peticionServicio: { esPrueba: false },
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));

            // se asignan los valores del usuario
            if(!CON_ERROR && campoEsValido({ campoAValidar: Usuario })) {
                console.log({ Usuario });
                const { AreaAsignado: { Nombre, Materias, JuzgadoId } } = Usuario;
                const MATERIA_AREA_DE_USUARIO = Materias[0];
                this.INFORMACION_AREA_USUARIO.MATERIA = (campoEsValido({ campoAValidar: Materias })) ? MATERIA_AREA_DE_USUARIO.Nombre : 'Sin materia'; 
                this.INFORMACION_AREA_USUARIO.NOMBRE_JUZGADO = Nombre;
                this.FILTROS.JUZGADO.valorDefinido = JuzgadoId;
                this.FILTROS.MATERIA.valorDefinido = MATERIA_AREA_DE_USUARIO.MateriaId;
            }
        },
        obtenerValores: (value, row) => {
            console.log({ value });
            console.log({ row });
        },
        obtenerListadoDeDomicilios: function(evento, accion){      

        },
        evtObtenerDomicilioPrincipal: function(domicilio) {

        },
        evtCambioTipoDeJurisdiccion: function(evento) {
            this.DATOS_CEDULA.JURISDICCIONES.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioTipoDeCedula: function(evento) {
            this.DATOS_CEDULA.TIPO_CEDULA.valorDefinido = parseInt(evento.target.value);
            if(!this.mostrarOpcionTipoDeAudiencia && campoEsValido({ campoAValidar: this.DATOS_CEDULA.TIPO_AUDIENCIA.valorDefinido })) {
                // se limpia el catalogo de los tipos de audiencia
                this.DATOS_CEDULA.TIPO_AUDIENCIA.valorDefinido = -1;
                this.DATOS_CEDULA.TIPO_AUDIENCIA.contRender ++;
            }
            else if(this.mostrarOpcionesDeSentencias) {
                this.DATOS_CEDULA.fechaDeDictadoDeSentencia = null;
            }
        },
        evtCambioOpcionOrdenDeProteccion: function(evento) {
            this.DATOS_CEDULA.ORDEN_PROTECCION.valorDefinido = parseInt(evento.target.value);
            console.log('orden::' + this.DATOS_CEDULA.ORDEN_PROTECCION.valorDefinido);
            this.DATOS_CEDULA.numeroOrdenProteccion = (this.DATOS_CEDULA.ORDEN_PROTECCION.valorDefinido) == 2 ? null : this.DATOS_CEDULA.numeroOrdenProteccion;
        },
        evtCambioTipoDeAudiencia: function(evento) {
            this.DATOS_CEDULA.TIPO_AUDIENCIA.valorDefinido = parseInt(evento.target.value);
        },
        agregarReprentanteAListadoPorFormulario: function() { 
            this.$nextTick(async () => {
                const REPRESENTANTE_STR = `${ this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre }${ this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno }${ campoEsValido({ campoAValidar: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno }) ? this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno : ''}`
                const { ID_TABLA } = this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO;
                if(campoEsValido({ campoAValidar: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista })) {
                    const YA_EXISTE_REP_CON_ESE_NOMBRE = (
                        this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista.map(r => { 
                            // se hace la validacion para no concatenar undefined o null lo cual podria provocar un mal comportamiento de la funcion esLaMismaCadena(), 
                            // en el caso en que el campo no se ingrese
                            let apellidoMaterno = campoEsValido({ campoAValidar: r.apellidoMaterno }) ? r.apellidoMaterno : '';
                            return (r.nombre + r.apellidoPaterno + apellidoMaterno) 
                        })
                        .some(rStrUnificado => esLaMismaCadena({ cadenaInicial: rStrUnificado, compararCon: REPRESENTANTE_STR }))
                    );

                    if(!YA_EXISTE_REP_CON_ESE_NOMBRE) {
                        this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados ++;
                        this.agregarFilaRepresentanteLegalPorFormulario({ posicionDeFila: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista.length });
                    }
                    else {
                        comun.mensajeDeAlerta('ya se encuentra un representante con ese nombre en la lista');
                    }
                }
                else {
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados ++;
                    const REPRESENTANTE_OBJ = {  
                        id: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados,
                        nombre: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre,
                        apellidoPaterno: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno,
                        apellidoMaterno: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno
                    };
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista = [ REPRESENTANTE_OBJ ];
                    await Promise.resolve(this.inicializarTabla({ elementos: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista, idTabla: ID_TABLA }));
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre = null;
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno = null;
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno = null;
                }
            });
        },
        agregarFilaRepresentanteLegalPorFormulario: function({ posicionDeFila, limpiarVariables = true }) { 
            console.log('posicionDeFila::' + posicionDeFila);
            const { ID_TABLA } = this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO;
            const REPRESENTANTE_OBJ = {  
                id: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados,
                nombre: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre,
                apellidoPaterno: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno,
                apellidoMaterno: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno
            };
            $("#" + ID_TABLA).bootstrapTable('insertRow', {
                index: posicionDeFila, 
                row: REPRESENTANTE_OBJ
            });

            // se limpian las varibales del formulario
            if(limpiarVariables) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre = null;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno = null;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno = null;
            }
        },
        filtrarOpcionesCatalogoTiposReperentantesLegales: function({ mostrarCompleto }) {
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.LISTA = [ { llave: 1, valor: 'Quien acredite su legal representación' } ];
            if(mostrarCompleto) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.LISTA.push({ llave: 2, valor: 'Representante legal de empresa' });
            }
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido = (!mostrarCompleto && this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido > 1) 
                ? -1 : this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido;
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.contRender ++;
        },
        evtCambioEmpresa: async function(evento, empresaObj) { 
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.seleccionado = empresaObj;
            if(campoEsValido({ campoAValidar: empresaObj })) {
                let domicilios = [
                        { id: 1, calle: 'calle de prueba 1', numero: '1', fraccionamiento: 'f1', codifoPostal: 'c1', municipio: 'mun1', referencias: '' },
                        { id: 2, calle: 'calle de prueba 1', numero: '2', fraccionamiento: 'f2', codifoPostal: 'c2', municipio: 'mun2', referencias: '' },
                        { id: 3, calle: 'clle de prueba 1', numero: '3', fraccionamiento: 'f3', codifoPostal: 'c3', municipio: 'mun3', referencias: '' }
                    ]
                this.filtrarOpcionesCatalogoTiposReperentantesLegales({ mostrarCompleto: true });
                await Promise.resolve(this.inicializarTabla({ elementos: domicilios, idTabla: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.ID_TABLA_DOMICILIOS }));
            }
            else {
                this.filtrarOpcionesCatalogoTiposReperentantesLegales({ mostrarCompleto: false });
                this.limpiarDomiciliosDeEmpresaCatalogo({ conTabla: true, conLista: true });
            }
        },
        evtOpcionDesdeCatalogoPersonaMoral: function() {
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo = !this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo;
            this.limpiarFormularioPersonaMoral({ conCamposDeCatalogo: !this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo, conCamposDeFormulario: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo });
            this.filtrarOpcionesCatalogoTiposReperentantesLegales({ mostrarCompleto: false });
        },
        evtOpcionAgregarRepersentantePorFormulario: function() { 
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario = !this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario;
            if(!this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario) {
                this.limpiarDatosRepresentanteLegalFormulario({ conOpcionDeActivacion: false, conTablaDeRepresentantes: false });
            }
        },
        obtenerHTMLAccionesPartes: () => {
            return [
                '<div>',
                    '<input id="btn-sleccion-parte-SINOJ-VCDCV2" name="parteANotificar" type="radio" class="form-check-input">',
                '</div>'
            ].join("");
        },
        obtenerHTMLAcuerdos: () => {
            return [
                '<div>',
                    '<button id="btn-ver-acuerdo-SINOJ-VCDCV2" title="Remover representante de listado" type="button" class="btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-eye"></i></button>',
                '</div>'
            ].join("");
        },
        obtenerHTMLAccionesAcuerdosSeleccionados: ({ radio, datetime }) => {
            let elementoHTML = ``
            if(radio) {
                elementoHTML = `<div>
                                  <input id="btn-sleccion-acuerdo-principal-SINOJ-VCDCV2" name="acuerdoPrincipal" type="radio" class="form-check-input">
                                </div>`;
            }
            else if(datetime) {
                elementoHTML = `<div>
                                    <input type="datetime-local" class="form-control col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                </div>`;
            }
            return elementoHTML;
        },
        obtenerHTMLAccionesDomiciliosEmpresas: () => {
            return [
                '<div>',
                    '<input id="btn-sleccion-domicilio-empresa-SINOJ-VCDCV2" name="parteANotificar" type="radio" class="form-check-input">',
                '</div>'
            ].join("");
        },
        obtenerHTMLAccionesRepresentantesLegalesFormulario: () => {
            return [
                '<div>',
                    '<button id="btn-remover-representante-SINOJ-VCDCV2" title="Remover representante de listado" type="button" class="btn btn-danger btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-minus-square"></i></button>',
                '</div>'
            ].join("");
        },
        inicializarTabla: async function({ elementos, idTabla, callBackAgregarElemento = ({ agregar, elemento }) => {} }) { 
            this.$nextTick(() => {
                $("#" + idTabla).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table click-row.bs.table");
                $("#" + idTabla).bootstrapTable({  data: elementos });    
                $("#" + idTabla).bootstrapTable('load', elementos ); 
                $("#" + idTabla).on('check.bs.table',(e, row) => {
                    callBackAgregarElemento({ agregar: true, elemento: row });
                    //this.evtEmpresaSeleccionada({ agregar: true, empresa: row });
                });
                $("#" + idTabla).on('uncheck.bs.table',(e, row) => {
                    callBackAgregarElemento({ agregar: false, elemento: row });
                    //this.evtEmpresaSeleccionada({ agregar: false, empresa: row });
                });
            });
        },
        evtAgregarAcuerdoSeleccionado: async function({ agregar, elemento }) { debugger
            const ACUERDO_SELECCIONADO = this.ACUERDOS_CEDULA.TABLA.listaOriginal.find(aDB => aDB.id == elemento.id);
            if(agregar) {
                if(campoEsValido({ campoAValidar: ACUERDO_SELECCIONADO })) {
                    const LISTA_SELECCION_ESTA_VACIA = (!campoEsValido({ campoAValidar: this.ACUERDOS_CEDULA.TABLA.seleccionados }));

                    // se inicializa la tabla
                    if(LISTA_SELECCION_ESTA_VACIA) {
                        this.ACUERDOS_CEDULA.TABLA.seleccionados = [ ACUERDO_SELECCIONADO ];
                        await Promise.resolve(this.inicializarTabla({ elementos: this.ACUERDOS_CEDULA.TABLA.seleccionados, idTabla: this.ACUERDOS_CEDULA.TABLA.ID_SELECCIONADOS }));
                    }
                    else {
                        // se agrega el acuerdo a la tabla
                        const ULTIMA_POSICION = !LISTA_SELECCION_ESTA_VACIA ? this.ACUERDOS_CEDULA.TABLA.seleccionados.length : 0;
                        $("#" + this.ACUERDOS_CEDULA.TABLA.ID_SELECCIONADOS).bootstrapTable('insertRow', {
                            index: ULTIMA_POSICION, 
                            row: ACUERDO_SELECCIONADO
                        });
                    }
                }
            }
            else {
                $("#" + this.ACUERDOS_CEDULA.TABLA.ID_SELECCIONADOS).bootstrapTable('remove', {
                    field: 'id',
                    values: [elemento.id]
                });

                // se lemina la instancia de la tabla
                this.$nextTick(() => {
                    if(campoEsValido({ campoAValidar: this.ACUERDOS_CEDULA.TABLA.seleccionados })) {
                        $("#" + this.ACUERDOS_CEDULA.TABLA.ID_SELECCIONADOS).bootstrapTable('destroy');
                    }
                });
            }
        },
       /*  iniciarProcesoBusquedaExpediente: function() {
            this.FILTROS.CONDICIONALES.seRealizoBusquedaExpediente = true;
            this.FILTROS.CONDICIONALES.seEncontroExpediente = !this.FILTROS.CONDICIONALES.seEncontroExpediente;
        }, */
        evtCambioTipoDocumento: function(evento) {
            this.FILTROS.TIPO_DOCUMENTO.valorDefinido = parseInt(evento.target.value);
            const TIPO_TERCERIA_ID = 2;
            const TIPO_INCIDENTE_ID = 10
            this.FILTROS.CONDICIONALES.mostrarNumeroExtra = (this.FILTROS.TIPO_DOCUMENTO.valorDefinido == TIPO_TERCERIA_ID || this.FILTROS.TIPO_DOCUMENTO.valorDefinido == TIPO_INCIDENTE_ID);
            // se limpia el valor del numero extra del expediente
            this.FILTROS.TIPO_DOCUMENTO.numeroExtra = (this.FILTROS.CONDICIONALES.mostrarNumeroExtra) ? this.FILTROS.CONDICIONALES.mostrarNumeroExtra : null;
        },
        evtCambioTipoMateria: function(evento) {
            this.FILTROS.MATERIA.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioTipoJuzgado: function(evento) {
            this.FILTROS.JUZGADO.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioTipoDePersonaANotificar: async function(evento) {
            this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido = parseInt(evento.target.value);
            switch (this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido) {
                case 1: // fisica
                    this.limpiarDomiciliosDeEmpresaCatalogo({ conTabla: true, conLista: true });
                    this.limpiarFormularioPartes();
                    this.limpiarFormularioPersonaMoral({ conCamposDeCatalogo: true, conCamposDeFormulario: true });
                    break;
                case 2: // moral
                    this.filtrarOpcionesCatalogoTiposReperentantesLegales({ mostrarCompleto: false });
                    this.limpiarFormularioPersonaFisica();
                    this.limpiarFormularioPartes();
                    break;
                case 3: // parte
                    this.limpiarDomiciliosDeEmpresaCatalogo({ conTabla: true, conLista: true });
                    this.limpiarFormularioPersonaFisica();
                    this.limpiarFormularioPersonaMoral({ conCamposDeCatalogo: true, conCamposDeFormulario: true });
                    if(campoEsValido({ campoAValidar: this.FILTROS.expedienteObj.Personas })) {
                        await Promise.resolve(this.construirTablaDePartes({ partes: this.FILTROS.expedienteObj.Personas }));
                    }
                    break;   
                default:
                    this.limpiarDomiciliosDeEmpresaCatalogo({ conTabla: true, conLista: true });
                    this.limpiarFormularioPartes();
                    this.limpiarFormularioPersonaFisica();
                    this.limpiarFormularioPersonaMoral({ conCamposDeCatalogo: true, conCamposDeFormulario: true });
                    break;
            }
        },
        limpiarFormularioPartes: function() {
             $("#" + this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID).bootstrapTable('destroy');
             this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.seleccionado = null;
             this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.seleccionados = [];
             this.PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido = -1;
        },
        limpiarFormularioPersonaFisica: function() {
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.nombre = null;
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.apellPaterno = null;
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.apellMaterno = null;
            
            // SE LIMPIA EL CATALOGO DE PERSONALIDADES
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.valorDefinido = -1;
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.contRender++;
        },
        limpiarFormularioPersonaMoral: function({ conCamposDeCatalogo, conCamposDeFormulario }) {
            if(conCamposDeCatalogo) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.valorDefinido = -1;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.contRender ++;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido = 1;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.contRender ++;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.formaRepresentanteLegal = null;
                this.limpiarDomiciliosDeEmpresaCatalogo({ conTabla: true, conLista: true });
            }

            if(conCamposDeFormulario) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.nombre = null;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.valorDefinido = -1;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.TIPO_PERSONALIDAD.contRender ++;
            }

            this.limpiarDatosRepresentanteLegalFormulario({ conOpcionDeActivacion: true });
        },
        limpiarDomiciliosDeEmpresaCatalogo: function({ conTabla, conLista }) {
            if(conLista) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.seleccionado = null;
            }

            if(conTabla) {
                $("#" + this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.ID_TABLA_DOMICILIOS).bootstrapTable('destroy');
            }
        },
        limpiarDatosRepresentanteLegalFormulario: function({ conOpcionDeActivacion, conTablaDeRepresentantes = true }) {
            if(conOpcionDeActivacion) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario =  false;
            }

            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre = null;
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno = null;
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellMaterno = null;
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados = 0;

            if(conTablaDeRepresentantes) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista = [];
                $("#" + this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.ID_TABLA).bootstrapTable('destroy');
            }
        },
        evtCambioSeNotificaEnJuzgado: function(evento) {
            this.PERSONA_NOTIFICAR.TIPOS_RESULTADO.valorDefinido = parseInt(evento.target.value);
            this.PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido = (this.PERSONA_NOTIFICAR.TIPOS_RESULTADO.valorDefinido == 1) ? this.PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido : 2;
        },
        evtCambioEsPorEstrados: async function(evento) {
            this.PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido = parseInt(evento.target.value);
            let idTablaActaulizar = (this.PERSONA_NOTIFICAR.TIPOS_NOT_EN_JUZGADO.valorDefinido == 1) ? this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID_ESTRADOS : this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID;
            $("#" + this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID).bootstrapTable('destroy');
            let partes = [
                { id: 1, Nombre: 'Usuario parte de prueba 1', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' },
                { id: 2, Nombre: 'Usuario parte de prueba 2', TipoPersona: 'Moral', TipoPersonalidad: 'Demandado' },
                { id: 3, Nombre: 'Usuario parte de prueba 3', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' }
            ]
            await Promise.resolve(this.inicializarTabla({ elementos: partes, idTabla: idTablaActaulizar }));
            /* this.$nextTick(async () => {
                let partes = [
                    { id: 1, Nombre: 'Usuario parte de prueba 1', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' },
                    { id: 2, Nombre: 'Usuario parte de prueba 2', TipoPersona: 'Moral', TipoPersonalidad: 'Demandado' },
                    { id: 3, Nombre: 'Usuario parte de prueba 3', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' }
                ]
                await Promise.resolve(this.inicializarTabla({ elementos: partes, idTabla: idTablaActaulizar }));
            }); */
        },
        evtCambioTipoPersonalidad: function(evento) {
            this.PERSONA_NOTIFICAR.FORMULARIOS.FISICA.TIPO_PERSONALIDAD.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioTipoRepresentante: function(evento) { 
            this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido = parseInt(evento.target.value);
            if(this.mostrarRepresentantesDeEmpresaCatalogo) {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.LISTA = [{ llave: 1, valor: 'persona representante legal' }];
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.contRender ++;
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.formaRepresentanteLegal = null;
            }
            else {
                this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.EMPRESAS.REPRESENTANTE_LEGAL.LISTA = [];
            }
        },
        /**
         * @param {string} somebody Somebody's name.
         */
        imprimir: function(somebody) {
            /** @type {String} */
            let cadena = '';
        },
        imprimirDos: function() {
            this.imprimir('');
        }
    },
    computed: {
        mostrarRepresentantesDeEmpresaCatalogo() {
            // 2 = id que indica que se eligio la opcion para selecciona a uno de los representantes legales de la empresa o institucion
            return (this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL.valorDefinido == 2);
        },
        mostrarOpcionEsPorEstrado() {
            // TIPO_RESULTADO_NOT = 1 (Se notifica en juzgado)
            // TIPO_PERSONA = 3 (El tipo de persona a notificar es una parte)
            return (this.PERSONA_NOTIFICAR.TIPOS_RESULTADO.valorDefinido == 1 && this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido == 3);
        },
        mostrarOpcionAgregarRepresentanteEnLista() {
            return (
                !this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo && 
                 this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.mostrarFormulario &&
                 (
                    campoEsValido({ campoAValidar: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.nombre }) &&
                    campoEsValido({ campoAValidar: this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.apellPaterno })
                 )
            );
        },
        mostrarOpcionTipoDeAudiencia() {
            return this.ID_TIPOS_AUDIENCIA.some(id => id == this.DATOS_CEDULA.TIPO_CEDULA.valorDefinido);
        },
        mostrarOpcionesDeSentencias() {
            return (this.ID_TIPOS_SENTENCIA.some(id => id == this.DATOS_CEDULA.TIPO_CEDULA.valorDefinido));
        },
        mostrarSeccionDeDomicilios() {
            return (
                (this.FILTROS.CONDICIONALES.seRealizoBusquedaExpediente && this.PERSONA_NOTIFICAR.TIPOS_PERSONA.valorDefinido == 2)
                    ? !this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.agregarDesdeCatalogo
                    : this.FILTROS.CONDICIONALES.seRealizoBusquedaExpediente
            );
        }
    },
    async created() {
        if(!this.FILTROS.CONDICIONALES.esJuzgadoMixto)
            this.obtenerDatosDeUsuario();
    },
    async mounted() {
        window.operateEvents = {
            "change #btn-sleccion-parte-SINOJ-VCDCV2": (e,val,row,index) => {   
                this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.seleccionado = this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.listaOriginal.find(pDB => pDB.id == row.id);
            },
            "change #btn-sleccion-domicilio-empresa-SINOJ-VCDCV2": (e,val,row,index) => {   
                
            },
            "click #btn-remover-representante-SINOJ-VCDCV2": (e,val,row,index) => {   
                $("#" + this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.ID_TABLA).bootstrapTable('remove', {
                    field: 'id',
                    values: [row.id]
                });

                // se reinicia el contador de representantes legales
                if(this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.lista < 1) {
                    this.PERSONA_NOTIFICAR.FORMULARIOS.MORAL.REPRESENTANTE_LEGAL_FORMULARIO.contadorRepresentantesAgregados = 0;
                }
            },
            "click #btn-ver-acuerdo-SINOJ-VCDCV2": (e,val,row,index) => {   
                
            },
            "change #btn-sleccion-acuerdo-principal-SINOJ-VCDCV2": (e,val,row,index) => {   
                
            },
        };
        /* let partes = [
                { id: 1, Nombre: 'Usuario parte de prueba 1', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' },
                { id: 2, Nombre: 'Usuario parte de prueba 2', TipoPersona: 'Moral', TipoPersonalidad: 'Demandado' },
                { id: 3, Nombre: 'Usuario parte de prueba 3', TipoPersona: 'Fisica', TipoPersonalidad: 'Actor' }
            ]
        await Promise.resolve(this.inicializarTabla({ elementos: partes, idTabla: this.PERSONA_NOTIFICAR.FORMULARIOS.PARTES.ID })); */
        /*
         <th data-halign="center" data-width="5" data-align="center" data-field="id" data-sortable="true">
                                                            Folio
                                                        </th>
                                                        <th data-halign="center" data-width="30" data-align="center" data-field="tipoDeDocumento" data-sortable="true">
                                                            Tipo de documento
                                                        </th>
                                                        <th data-halign="center" data-width="30" data-align="center" data-field="extracto" data-sortable="true">
                                                            Extracto
                                                        </th>
                                                        <th data-halign="center" data-width="30" data-align="center" data-field="fechaDePublicacion" data-sortable="true">
                                                            Fecha de publicacion
                                                        </th> 
         */
        this.ACUERDOS_CEDULA.TABLA.listaOriginal = [
                { id: 5018409, tipoDeDocumento: 'EXPEDIENTE PRINCIPAL', extracto: 'SENTENCIA DEFINITIVA CAUSA EJECUTORIA.- SE CONCEDE EL TERMINO DE CINCO DÍAS PARA QUE LA PARTE DEMANDADA CUMPLA VOLUNTARIAMENTE CON LA MISMA, APERCIBIDA EN CASO DE NO HACERLO SE DESPACHARÁ EJECUCIÓN EN SU CONTRA.', fechaDePublicacion: '14-12-2020' },
                { id: 4925108, tipoDeDocumento: 'EXPEDIENTE PRINCIPAL', extracto: 'SE DESAHOGA AUDIENCIA 353 DEL CODIGO DE PROCEDIMIENTOS CIVILES, SE CITA PARA SENTENCIA', fechaDePublicacion: '14-12-2020' },
                { id: 4851530, tipoDeDocumento: 'EXPEDIENTE PRINCIPAL', extracto: 'SE DESAHOGA AUDIENCIA 353 DEL CODIGO DE PROCEDIMIENTOS CIVILES, SE CITA PARA SENTENCIA', fechaDePublicacion: '14-12-2020' }
            ]
        
        await Promise.resolve(this.inicializarTabla({ elementos: this.ACUERDOS_CEDULA.TABLA.listaOriginal, idTabla: this.ACUERDOS_CEDULA.TABLA.ID, callBackAgregarElemento: this.evtAgregarAcuerdoSeleccionado }));
    },
}
</script>
<style scoped>
.seccion-deshabilitada {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

ul.progress li.active {
    background-color: #476072;
}

ul.progress li {
    background-color: #1f1f21;
    text-align: center;
    cursor: pointer;
}

ul {
    height: 40px;
    border: 1px solid white;
}

ul.progress {
    list-style: none;
    margin: 0;
    padding: 0;
}

ul.progress li {
    float: left;
    line-height: 40px;
    height: 40px;
    min-width: 130px;
    position: relative;
}

ul.progress li:after {
	content: '';
    position: absolute;
	width: 0;
	height: 40px;
    right: 4px;
    border-style: solid;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent #1f1f21;
}

ul.progress li:before {
	content: '';
    position: absolute;
	width: 0;
	height: 40px;
    right: 0px;
    border-style: solid;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent #fff;
}

ul.progress li.beforeactive:before {
    background-color: #476072;
}

ul.progress li.active:before {
    background-color: #1f1f21;
}
ul.progress li.active:after {
    border-color: transparent transparent transparent #476072;
}

ul.progress li:last-child:after,
ul.progress li:last-child:before {
    border: 0;
}

ul.progress li a {
    padding: 0px 0px 0px 0px;
    color: #FFF;
    text-decoration: none;
    text-align: center;
    font-size: 1.3em;
    font-weight: bold;
}

/* FIN SECCION ESTILOS PARA MENU */
.espacio-entre-secciones {
    margin-top: 4em;
}
#contendor-principal-VCDCV2 .btn-info {
    background-color: #476072 !important;
    border: 1px solid #334257 !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

#seccion-principal-VCDCV2 {
    padding-top: 3em;
}

#seccion-principal-VCDCV2 .card {
    border: 1px solid rgb(44, 44, 44) !important;
}

#seccion-principal-VCDCV2 .card-header {
    background-color: black;
}

#seccion-principal-VCDCV2 .card-body {
    background-color: rgb(61, 61, 61);
    padding: 1em 2em 2em 2em !important;
}

#info-cedula .card-body {
    background-color: rgb(88, 88, 88);
    padding: 2em 2em 2em 2em !important;
}

#seccion-principal-VCDCV2 {
    padding-top: 3em;
}

#encabezados {
    margin-bottom: 1em;
}

#encabezados h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}

.filtros .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
    border: none;
}

.filtros .form-control {
    border: none !important;
}

.contenedor-formularios {
    padding: 1.5em 2em 1em 2em;
    margin-bottom: 1.3em;
    background-color: rgb(53, 53, 53);
    border-radius: 4px;
    border: 1px solid rgb(114, 114, 114);
}

.contenedor-encabezados-informativos {
    padding: 1em 1em 0.5em 1em;
    margin-bottom: 1.3em;
    background-color: rgb(41, 41, 41);
    border-radius: 4px;
    border: 1px solid rgb(114, 114, 114);
}
</style>
<style>
.contenedor-tabla-SINOJ-VCDCV2 .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.contenedor-tabla-SINOJ-VCDCV2 .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.contenedor-tabla-SINOJ-VCDCV2 td {
    /* background-color: rgb(238, 238, 238);
    vertical-align: middle; */
    cursor: pointer;
    background-color: rgb(187, 187, 187);
}

.contenedor-tabla-SINOJ-VCDCV2 tr.custom--success td {
    background-color: #5e5e5e; /*custom color here add !important if you don't want the hover color*/
    color: white;
}

.contenedor-tabla-SINOJ-VCDCV2 table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.contenedor-tabla-SINOJ-VCDCV2 .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #111111;
    font-size: 1em;
}

.contenedor-tabla-SINOJ-VCDCV2 .btn-acciones-tabla-empresas-VRDE:hover, .contenedor-tabla-SINOJ-VCDCV2 .btn-acciones-tabla-empresas-VRDE:focus {
    background-color: #1c1d1d;
    border: 1px solid #e1e2e2;
    color: white;
}

.contenedor-tabla-SINOJ-VCDCV2 .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.contenedor-tabla-SINOJ-VCDCV2 .bs-checkbox .th-inner {
    pointer-events:none !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
}

.contenedor-tabla-SINOJ-VCDCV2 .pagination > li > a {
    background-color: white;
    color: #121213;
}

.contenedor-tabla-SINOJ-VCDCV2 .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.contenedor-tabla-SINOJ-VCDCV2 > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/Creacion/V2/CCreacionCedula.vue